module.exports = __webpack_public_path__ + "img/dashboard.020d64ed.png";